import type { StepValues as StepValuesType } from "../types";

export const StepValues: StepValuesType = {
  GET_STARTED: "get-started",
  TRANSACTION_DETAILS: "transaction-details",
  PAYMENT: "payment",
  PAYMENT_PLAN_OVERVIEW: "payment-plan-overview",
};
